import { defineStore } from "pinia";
import { deleteRequest, postRequest } from "~/apis/requests/useApiCall";

export const useCrmAttachmentsStore = defineStore("crmAttachmentsStore", {
  state: () => ({}),
  getters: {},
  actions: {
    async addAttachment(data: any) {
      const { response, error } = await postRequest<any>(
        "crm/attachments",
        data,
        true,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (!error) {
        return response;
      }
      return null;
    },

    async deleteAttachment(id: number) {
      return await deleteRequest(`crm/attachments/${id}`);
    },
  },
});
